import React, { useMemo } from "react";
import { Creator } from "../../../../api/staff";
import { useTranslations } from "../../../../contexts/translation.context";
import { getCreatorStatusConfig } from "../constants";

interface CreatorStatusCellProps {
  creator: Creator;
}

const CreatorStatusCell: React.FC<CreatorStatusCellProps> = ({ creator }) => {
  const { t } = useTranslations();

  const statusConfig = useMemo(
    () => getCreatorStatusConfig(creator.status, t),
    [creator.status, t]
  );

  return (
    <span
      className="inline-flex h-[24px] items-center justify-center rounded-lg px-[8px] text-[12px] font-medium whitespace-nowrap"
      style={{
        backgroundColor: `${statusConfig.color}20`,
        color: statusConfig.color
      }}
    >
      {statusConfig.label}
    </span>
  );
};

export default CreatorStatusCell;
